import { HeaderLanguageDropdown } from "common/components/Select/languageDropdown";
import { HeaderButtonContainer } from "common/components/Wrapper/headerButton";
import { HEADER_HEIGHT } from "common/const/const";
import { TextTitle4 } from "common/components";
import styled from "styled-components";
import { colors } from "common/const/colors";
import { Settings16Icon } from "common/components/icon";
import { useLocation } from "react-router";
import { useEffect, useRef, useState } from "react";
import { showMessageModal } from "common/utils/modalController";
import { HeaderNotificationButton } from "./Notification/NotificationButton";

const StyledHeader = styled.header`
  display: flex;
  position: ${({ transparent }) => (transparent ? "fixed" : "sticky")};
  top: 0;
  right: 0;
  width: ${({ transparent }) => (transparent ? "100vw" : "auto")};
  min-height: ${HEADER_HEIGHT};
  background-color: ${({ transparent }) =>
    transparent ? "transparent" : colors.White};
  border-bottom: ${({ transparent }) =>
    transparent ? "none" : `0.5px solid ${colors.Gray}`};
  justify-content: flex-end;
  align-items: center;
  z-index: 900;
  padding: 0 0.75rem;

  box-sizing: border-box;
`;

export const Header = ({ isStatic }) => {
  const location = useLocation();
  const [userName, setUserName] = useState();
  const [popupIdList, setPopupIdList] = useState([]);
  const isProcessing = useRef(false);

  const triggerModal = (id, msg) => {
    isProcessing.current = true;

    showMessageModal(msg, () => {
      isProcessing.current = false;

      setPopupIdList((prev) => {
        return prev.filter((item) => item !== id);
      });
    });
  };

  // 🔔 Listen for Service Worker postMessage events
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator))
      return;

    const handleServiceWorkerMessage = (event) => {
      const { type, payload } = event.data || {};

      if (type === "NOTIFICATION_CLICK") {
        console.log("Real-time notification click:", payload);

        // 알림 클릭 시 권한 여부와 무관하게 탭 포커스 및 패널 오픈
        window.focus();
        window.dispatchEvent(new CustomEvent("open-notification-panel"));
      }

      if (type === "PUSH_NOTIFICATION_RECEIVED") {
        console.log("Real-time push received (권한 상관없이 실행됨):", payload);

        // 안전한 데이터 참조
        const popupId =
          payload?.payload?.reservationPlayerId || payload?.id || Date.now();

        if (isProcessing.current) {
          setPopupIdList((prev) => [...prev, popupId]);
          return;
        }

        // SSE 이벤트 디스패치 (알림 권한과 무관하게 실행)
        const sseEvent = new CustomEvent("sse-message", {
          detail: payload,
        });
        window.dispatchEvent(sseEvent);
      }
    };

    navigator.serviceWorker.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        "message",
        handleServiceWorkerMessage,
      );
    };
  }, []);

  useEffect(() => {
    setUserName(localStorage.getItem("userName"));
  }, [location.pathname]);

  return (
    <StyledHeader transparent={!isStatic}>
      {localStorage.getItem("clubId") && <HeaderNotificationButton />}
      <HeaderLanguageDropdown />
      {userName && (
        <HeaderButtonContainer
          onClick={() => (window.location.href = "/profile")}
        >
          <TextTitle4>{userName}</TextTitle4>
          <Settings16Icon />
        </HeaderButtonContainer>
      )}
    </StyledHeader>
  );
};
